const PENDING_PASSWORD_RESET_STORAGE_KEY = 'bustly:pending_password_reset';

export interface PendingPasswordResetState {
    email: string;
    sessionVerified: boolean;
}

function getSessionStorage(): Storage | null {
    if (typeof window === 'undefined') return null;
    return window.sessionStorage;
}

function parsePendingPasswordReset(rawValue: string | null): PendingPasswordResetState | null {
    if (!rawValue) return null;
    if (rawValue === '1') {
        return {
            email: '',
            sessionVerified: false,
        };
    }

    try {
        const parsed = JSON.parse(rawValue) as Partial<PendingPasswordResetState>;
        return {
            email: typeof parsed.email === 'string' ? parsed.email : '',
            sessionVerified: parsed.sessionVerified === true,
        };
    } catch {
        return null;
    }
}

export function readPendingPasswordReset(): PendingPasswordResetState | null {
    try {
        return parsePendingPasswordReset(getSessionStorage()?.getItem(PENDING_PASSWORD_RESET_STORAGE_KEY) || null);
    } catch {
        return null;
    }
}

export function markPendingPasswordReset(nextState: Partial<PendingPasswordResetState> = {}) {
    try {
        const previousState = readPendingPasswordReset();
        getSessionStorage()?.setItem(
            PENDING_PASSWORD_RESET_STORAGE_KEY,
            JSON.stringify({
                email: nextState.email ?? previousState?.email ?? '',
                sessionVerified: nextState.sessionVerified ?? previousState?.sessionVerified ?? false,
            }),
        );
    } catch {
        // The auth page still owns the visible reset state if storage is unavailable.
    }
}

export function clearPendingPasswordReset() {
    try {
        getSessionStorage()?.removeItem(PENDING_PASSWORD_RESET_STORAGE_KEY);
    } catch {
        // Ignore storage failures.
    }
}

export function hasPendingPasswordReset(): boolean {
    return readPendingPasswordReset() !== null;
}
